<template><section><h3>面向海洋环境安全保障的极端风和浪事件的智能分析系统</h3>
<h4>背景介绍：</h4>
<p>极端海面风和极端海浪直接影响海上交通、港口运行、海洋工程、渔业生产、搜救与沿海防灾。风是局地风浪生成的主要驱动力，涌浪又可跨海盆传播，因此危险过程既包括极端风或极端浪单独发生，也包括二者同时、滞后或空间错位的复合事件。</p>
<p>再分析资料为长期气候统计提供一致的时空覆盖，业务预报资料为未来数小时至十余天的安全保障提供输入。两类数据的定位不同：ERA5 适合历史事件目录和多尺度变化研究，GFS/GFS-Wave 与 ECMWF Open Data 适合滚动预报和事件预警原型。</p>
<p>本项目拟构建一套任务驱动的离线智能分析系统，自动识别极端风、极端浪和极端风—浪复合事件，输出发生时间、结束时间、持续时长、峰值强度、累计强度、空间范围和不同尺度发生频率，并分析其与主要气候模态的联系。</p>
<p>系统借鉴《The multiscale variability of global extreme wind and wave events and their relationships with climate modes》的多尺度研究思想，同时吸收近期沿海波浪危险研究对热带气旋和气候驱动风场的关注。</p>
<h4>项目要求：</h4>
<ol>
<li>建立统一的海面风和波浪数据底座。
<ul>
<li>统一 10 米风分量、阵风、有效波高、平均波周期、峰值波周期、平均波向、风浪与涌浪分量的变量、单位、网格、时间和质量标识。</li>
</ul>
</li>
<li>识别可追溯的单一极端风和极端浪事件。
<ul>
<li>输出每个事件的起止时间、持续小时、峰值、平均超阈强度、累计超阈强度、最大影响面积、质心轨迹和区域事件编号。</li>
</ul>
</li>
<li>识别同时和滞后的极端风—浪复合事件。
<ul>
<li>区分同时型、风领先型、浪领先型、局地风浪型和远源涌浪型，输出共现时长、响应滞后、空间重叠、方向一致性和共现概率增强。</li>
</ul>
</li>
<li>分析多尺度变化。
<ul>
<li>统计天气尺度事件过程、季节变化、年际异常和年代际趋势，并分析与 ENSO、PDO、NAO、SAM、AMO 等气候模态的关系。</li>
</ul>
</li>
<li>形成历史统计与业务预报双模式。
<ul>
<li>历史模式形成稳定的气候基准和事件目录；预报模式按新预报循环更新未来风险，并保留不同起报时次的可预报性评估。</li>
</ul>
</li>
<li>构建受约束的离线 AI 助手。
<ul>
<li>AI 负责理解安全保障任务、选择数据与算法、解释结果和生成报告；所有风速、阈值、事件、统计和图形均由确定性工具计算。</li>
</ul>
</li>
</ol>
</section></template><script>export default {components:{}}</script>